(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define("sai-dashboard", ["jquery"], factory);
	else if(typeof exports === 'object')
		exports["sai-dashboard"] = factory(require("jquery"));
	else
		root["sai-dashboard"] = factory(root["jquery"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SAIDashboardLocalizable = /*#__PURE__*/function () {
  function SAIDashboardLocalizable(config) {
    _classCallCheck(this, SAIDashboardLocalizable);

    this.config = config;
  }

  _createClass(SAIDashboardLocalizable, [{
    key: "getId",
    value: function getId() {
      return this.config.id !== undefined ? this.config.id : '';
    }
  }, {
    key: "getRow",
    value: function getRow() {
      return this.config.row !== undefined ? this.config.row : -1;
    }
  }, {
    key: "getColumn",
    value: function getColumn() {
      return this.config.column !== undefined ? this.config.column : -1;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.config.width !== undefined ? this.config.width : -1;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.config.height !== undefined ? this.config.height : -1;
    }
  }]);

  return SAIDashboardLocalizable;
}();

exports.SAIDashboardLocalizable = SAIDashboardLocalizable;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StringUtils = /*#__PURE__*/function () {
  function StringUtils() {
    _classCallCheck(this, StringUtils);
  }

  _createClass(StringUtils, null, [{
    key: "resolveTextProperties",
    value: function resolveTextProperties(text, context, keepUnresolved, unresolvedChar) {
      if (keepUnresolved === undefined) {
        keepUnresolved = false;
      }

      if (unresolvedChar === undefined) {
        unresolvedChar = '?';
      }

      if (!text) {
        return text;
      }

      var regex = /\$\{(.+?)\}/g;
      var matches = [];
      var match = regex.exec(text);

      while (match !== null) {
        matches.push(match[1]);
        match = regex.exec(text);
      }

      var toReplace = text;

      for (var strKey in matches) {
        var toMatch = '\$\{' + matches[strKey] + '\}';

        if ((context === undefined || context[matches[strKey]] === undefined) && !keepUnresolved) {
          toReplace = toReplace.replace(toMatch, unresolvedChar);
        } else {
          toReplace = toReplace.replace(toMatch, context[matches[strKey]]);
        }
      }

      return toReplace;
    }
  }, {
    key: "underscoreToCamelCase",
    value: function underscoreToCamelCase(label) {
      var regex = /(_.)/g;
      var matches = [];
      var match = regex.exec(label);

      while (match !== null) {
        matches.push(match[1]);
        match = regex.exec(label);
      }

      var toReplace = label;

      for (var strKey in matches) {
        toReplace = toReplace.replace(matches[strKey], matches[strKey].substring(1, 2).toUpperCase());
      }

      return toReplace;
    }
  }]);

  return StringUtils;
}();

exports["default"] = StringUtils;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SAITileContent = /*#__PURE__*/function () {
  function SAITileContent(content) {
    _classCallCheck(this, SAITileContent);

    this.content = new SAIDashboardTileGridContent(content);
  }

  _createClass(SAITileContent, [{
    key: "getHeaders",
    value: function getHeaders() {
      return this.content.headers;
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return this.content.items;
    }
  }]);

  return SAITileContent;
}();

exports.SAITileContent = SAITileContent;

var SAIDashboardTileGridContent = function SAIDashboardTileGridContent(content) {
  _classCallCheck(this, SAIDashboardTileGridContent);

  this.headers = new Array();

  for (var headerIndex in content.headers) {
    this.headers.push(content.headers[headerIndex]);
  }

  this.items = new Array();

  for (var itemIndex in content.items) {
    this.items.push(new SAIDashboardTileGridItem(content.items[itemIndex]));
  }
};

exports.SAIDashboardTileGridContent = SAIDashboardTileGridContent;

var SAIDashboardTileGridHeader = function SAIDashboardTileGridHeader() {
  _classCallCheck(this, SAIDashboardTileGridHeader);
};

exports.SAIDashboardTileGridHeader = SAIDashboardTileGridHeader;

var SAIDashboardTileGridItemColumn = function SAIDashboardTileGridItemColumn() {
  _classCallCheck(this, SAIDashboardTileGridItemColumn);
};

exports.SAIDashboardTileGridItemColumn = SAIDashboardTileGridItemColumn;

var SAIDashboardTileGridItem = /*#__PURE__*/function () {
  function SAIDashboardTileGridItem(content) {
    _classCallCheck(this, SAIDashboardTileGridItem);

    this.icon = content.icon;
    this.iconNote = content.iconNote;
    this.iconNoteFull = content.iconNoteFull;
    this.columns = content.columns;
    this.overlay = content.overlay;
    this.chartsValues = content.chartsValues;
    this.styles = content.styles;
    this.hasNote = content.hasNote;
  }

  _createClass(SAIDashboardTileGridItem, [{
    key: "getColumnByDataIndex",
    value: function getColumnByDataIndex(dataIndex) {
      for (var index in this.columns) {
        if (this.columns[index].name === dataIndex) {
          return this.columns[index];
        }
      }

      return null;
    }
  }]);

  return SAIDashboardTileGridItem;
}();

exports.SAIDashboardTileGridItem = SAIDashboardTileGridItem;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_1 = __webpack_require__(5);

var sai_dashboard_group_view_1 = __webpack_require__(12);

var SAIDashboardView = /*#__PURE__*/function () {
  function SAIDashboardView(data, element) {
    _classCallCheck(this, SAIDashboardView);

    this.model = new sai_dashboard_1.SAIDashboard(data);
    this.parseGroups(this.model.getGroups());
    this.element = element;
  }

  _createClass(SAIDashboardView, [{
    key: "setElement",
    value: function setElement(element) {
      this.element = element;
    }
  }, {
    key: "parseGroups",
    value: function parseGroups(groupsConfig) {
      if (_typeof(groupsConfig) !== 'object') {
        console.error('groups attribute must be defined as an array of groups object. Expected [...] got ' + groupsConfig);
        return;
      }

      this.groupViews = [];
      this.groupViewsMap = {};

      for (var key in groupsConfig) {
        var newGroupView = new sai_dashboard_group_view_1.SAIDashboardGroupView(this, groupsConfig[key]);
        this.groupViews.push(newGroupView);
        this.groupViewsMap[newGroupView.getId()] = newGroupView;
      }
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      return this.groupViews;
    }
  }, {
    key: "getGroup",
    value: function getGroup(index) {
      return this.groupViews[index];
    }
  }, {
    key: "getGroupById",
    value: function getGroupById(id) {
      return this.groupViewsMap[id];
    }
  }, {
    key: "render",
    value: function render(colors, globalProps) {
      if (!this.element) {
        throw new Error('Missing element in dashboard to render. Call setElement first');
      }

      colors = colors || {};
      globalProps = globalProps || {};
      this.element.empty();
      this.element.addClass('sai-dashboard');
      this.contentNode = this.renderContentNode(colors);
      var maxHeight = this.renderGroups(this.contentNode, colors, globalProps);
      this.contentNode.height(maxHeight + this.getMargins());
      var backgroundImage = this.model.getBackground();

      if (backgroundImage) {
        this.element.css('background-image', backgroundImage);
      }
    }
  }, {
    key: "renderContentNode",
    value: function renderContentNode(colors) {
      var contentNode = $('<div></div>').appendTo(this.element);
      var computedMargins = this.getMargins();
      contentNode.css({
        'margin-top': computedMargins,
        'margin-left': computedMargins,
        'width': this.element.width() - 2 * computedMargins
      });
      contentNode.addClass('sai-dashboard-contents');
      contentNode.on('SAIDataRequest', this.requestHandler.bind(this, this.model.getDataCallback()));
      contentNode.on('SAIResourceRequest', this.requestHandler.bind(this, this.model.getResourceCallback()));
      return contentNode;
    }
  }, {
    key: "requestHandler",
    value: function requestHandler(dataCb, event, tileId, requestConfig, callback) {
      if (dataCb != null) {
        var dataPromise = dataCb(requestConfig);
        callback(dataPromise);
      }
    }
  }, {
    key: "renderGroups",
    value: function renderGroups(contentNode, colors, globalProps) {
      var groups = this.getGroups();
      var drawMode = this.getDrawMode();
      var squareSize = this.getSquareSize();
      var maxHeight = 0;
      var nextTopPosition = 0;

      for (var groupId in groups) {
        var groupElement = $('<div></div>').appendTo(contentNode);
        var currentGroup = groups[groupId];
        currentGroup.setElement(groupElement);

        if (drawMode === 'phone' || drawMode === 'tablet') {
          groupElement.width(contentNode.width());
          currentGroup.render(drawMode, squareSize, nextTopPosition, colors, globalProps);
          nextTopPosition = nextTopPosition + currentGroup.getRenderedHeight(drawMode, squareSize);
          maxHeight = Math.max(maxHeight, nextTopPosition);
        } else {
          currentGroup.render(drawMode, squareSize, -1, colors, globalProps);
          maxHeight = Math.max(maxHeight, currentGroup.getTopPosition(squareSize) + currentGroup.getRenderedHeight(drawMode, squareSize));
        }
      }

      return maxHeight;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.element.removeClass('sai-dashboard');
      this.element.empty();
    }
  }, {
    key: "getDrawMode",
    value: function getDrawMode() {
      var width = this.element.width();

      if (width >= 1024) {
        return 'wide';
      } else if (width >= 700) {
        return 'tablet';
      } else {
        return 'phone';
      }
    }
  }, {
    key: "getMargins",
    value: function getMargins() {
      var mode = this.getDrawMode();

      if (mode === 'tablet' || mode === 'phone') {
        return 0;
      } else {
        var width = this.element.width();
        var baseSize = width / (this.model.getWidth() + 2);
        return Math.min(100, Math.ceil((width - baseSize * this.model.getWidth()) / 2));
      }
    }
  }, {
    key: "getSquareSize",
    value: function getSquareSize() {
      return (this.element.width() - 2 * this.getMargins()) / this.model.getWidth();
    }
  }, {
    key: "addTileListener",
    value: function addTileListener(callback) {
      this.contentNode.on('SAITileClick', callback);
    }
  }, {
    key: "removeTileListeners",
    value: function removeTileListeners() {
      this.contentNode.off('SAITileClick');
    }
  }, {
    key: "setCallbacks",
    value: function setCallbacks(options) {
      for (var entry in options) {
        var cb = options[entry];

        if (entry === 'data') {
          this.model.setDataCallback(cb);
        } else if (entry === 'resource') {
          this.model.setResourceCallback(cb);
        } else {
          console.error('intialisation of unhandled callbacks ' + entry);
        }
      }
    }
  }, {
    key: "setBaseContext",
    value: function setBaseContext(baseContext) {
      this.baseContext = baseContext;
      var groups = this.getGroups();

      for (var groupId in groups) {
        groups[groupId].setBaseContext(baseContext);
      }
    }
  }, {
    key: "setGlobalProperties",
    value: function setGlobalProperties(props) {
      this.globalProps = props;
      var groups = this.getGroups();

      for (var groupId in groups) {
        groups[groupId].setGlobalProperties(props);
      }
    }
  }, {
    key: "setThemeColors",
    value: function setThemeColors(colors) {
      this.colors = colors;
      var groups = this.getGroups();

      for (var groupId in groups) {
        groups[groupId].setThemeColors(colors);
      }
    }
  }]);

  return SAIDashboardView;
}();

exports.SAIDashboardView = SAIDashboardView;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_group_1 = __webpack_require__(6);

var SAIDashboard = /*#__PURE__*/function () {
  function SAIDashboard(config) {
    _classCallCheck(this, SAIDashboard);

    this.groups = [];
    this.config = config;
    this.parseGroups();
  }

  _createClass(SAIDashboard, [{
    key: "parseGroups",
    value: function parseGroups() {
      this.groups = [];

      if (this.config.groups && this.config.groups.constructor === Array) {
        for (var key in this.config.groups) {
          this.groups.push(new sai_dashboard_group_1.SAIDashboardGroup(this.config.groups[key]));
        }
      }
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.config.id ? this.config.id : '';
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.config.label ? this.config.label : '';
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.config.width ? this.config.width : 24;
    }
  }, {
    key: "getGroups",
    value: function getGroups() {
      return this.groups;
    }
  }, {
    key: "getBackground",
    value: function getBackground() {
      return this.config.background ? this.config.background : '';
    }
  }, {
    key: "getDataCallback",
    value: function getDataCallback() {
      return this.config.dataCallback ? this.config.dataCallback : null;
    }
  }, {
    key: "setDataCallback",
    value: function setDataCallback(callback) {
      this.config.dataCallback = callback;
    }
  }, {
    key: "getResourceCallback",
    value: function getResourceCallback() {
      return this.config.resourceCallback ? this.config.resourceCallback : null;
    }
  }, {
    key: "setResourceCallback",
    value: function setResourceCallback(callback) {
      this.config.resourceCallback = callback;
    }
  }]);

  return SAIDashboard;
}();

exports.SAIDashboard = SAIDashboard;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_localizable_1 = __webpack_require__(1);

var sai_dashboard_tile_factory_1 = __webpack_require__(7);

var SAIDashboardGroup = /*#__PURE__*/function (_sai_dashboard_locali) {
  _inherits(SAIDashboardGroup, _sai_dashboard_locali);

  var _super = _createSuper(SAIDashboardGroup);

  function SAIDashboardGroup(config) {
    var _this;

    _classCallCheck(this, SAIDashboardGroup);

    _this = _super.call(this, config);
    _this.tiles = [];

    _this.loadTiles();

    return _this;
  }

  _createClass(SAIDashboardGroup, [{
    key: "loadTiles",
    value: function loadTiles() {
      this.tiles = [];

      if (this.config.tiles && this.config.tiles.constructor === Array) {
        for (var key in this.config.tiles) {
          this.tiles.push(sai_dashboard_tile_factory_1.SAITileFactory.buildTile(this.config.tiles[key], this));
        }
      }
    }
  }, {
    key: "getTiles",
    value: function getTiles() {
      return this.tiles;
    }
  }]);

  return SAIDashboardGroup;
}(sai_dashboard_localizable_1.SAIDashboardLocalizable);

exports.SAIDashboardGroup = SAIDashboardGroup;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_tile_1 = __webpack_require__(8);

var SAITileFactory = /*#__PURE__*/function () {
  function SAITileFactory() {
    _classCallCheck(this, SAITileFactory);
  }

  _createClass(SAITileFactory, null, [{
    key: "buildTile",
    value: function buildTile(tileConfig, parent) {
      if (!tileConfig || !tileConfig.type) {
        throw new Error('Invalid tile config. Config should be at least an object with a type property.');
      }

      var type = tileConfig.type;

      if (type === 'Task') {
        return new sai_dashboard_tile_1.SAIDashboardTaskTile(tileConfig, parent);
      } else if (type === 'Title') {
        return new sai_dashboard_tile_1.SAIDashboardTile(tileConfig, parent);
      } else if (type === 'Grid') {
        return new sai_dashboard_tile_1.SAIDashboardGridTile(tileConfig, parent);
      } else if (type === 'Agenda') {
        return new sai_dashboard_tile_1.SAIDashboardAgendaTile(tileConfig, parent);
      } else if (type === 'Filter') {
        return new sai_dashboard_tile_1.SAIDashboardFilterTile(tileConfig, parent);
      } else if (type === 'Graph') {
        return new sai_dashboard_tile_1.SAIDashboardGraphTile(tileConfig, parent);
      } else {
        throw new Error('Non valid tile type : ' + type);
      }
    }
  }]);

  return SAITileFactory;
}();

exports.SAITileFactory = SAITileFactory;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_localizable_1 = __webpack_require__(1);

var sai_tileconfig_1 = __webpack_require__(9);

var sai_tilevisual_1 = __webpack_require__(10);

var sai_tileaction_1 = __webpack_require__(11);

var sai_tilecontent_1 = __webpack_require__(3);

var SAIDashboardTile = /*#__PURE__*/function (_sai_dashboard_locali) {
  _inherits(SAIDashboardTile, _sai_dashboard_locali);

  var _super = _createSuper(SAIDashboardTile);

  function SAIDashboardTile(config, parent) {
    var _this;

    _classCallCheck(this, SAIDashboardTile);

    _this = _super.call(this, config);
    _this.parent = parent;

    _this.parseConfig(config.config || undefined);

    _this.parseVisual(config.visual || undefined);

    _this.parseAction(config.action || undefined);

    return _this;
  }

  _createClass(SAIDashboardTile, [{
    key: "parseVisual",
    value: function parseVisual(visualConfig) {
      this.tileVisual = new sai_tilevisual_1.SAITileVisual(visualConfig);
    }
  }, {
    key: "parseAction",
    value: function parseAction(actionConfig) {
      if (actionConfig && actionConfig.type === 'Task') {
        this.tileAction = new sai_tileaction_1.SAITileTaskAction(actionConfig);
      } else if (actionConfig && actionConfig.type === 'Notification') {
        this.tileAction = new sai_tileaction_1.SAITileNotificationAction(actionConfig);
      } else {
        this.tileAction = new sai_tileaction_1.SAITileTaskAction({});
      }
    }
  }, {
    key: "parseConfig",
    value: function parseConfig(tileConfig) {
      this.tileConfig = new sai_tileconfig_1.SAITileConfig(tileConfig);
    }
  }, {
    key: "getVisual",
    value: function getVisual() {
      return this.tileVisual;
    }
  }, {
    key: "getAction",
    value: function getAction() {
      return this.tileAction;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.tileConfig;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.config.type;
    }
  }, {
    key: "getPresentation",
    value: function getPresentation() {
      return this.config.presentation;
    }
  }, {
    key: "getLauncherParameters",
    value: function getLauncherParameters() {
      var parameters = {
        type: this.tileAction.getType(),
        taskId: this.tileAction.getTaskId() != undefined ? this.tileAction.getTaskId() : this.tileConfig.getTaskId()
      };

      if (parameters.type === 'Notification') {
        var notificationAction = this.tileAction;
        var notification = notificationAction.getNotification();

        if (notification != undefined && notification !== '') {
          parameters.notification = notification;
          parameters.notificationSource = notificationAction.getNotificationSource();
          parameters.notificationTask = notificationAction.getNotificationTask() !== '' ? notificationAction.getNotificationTask() : parameters.taskId;
        }
      } else {
        var taskAction = this.tileAction;
        var gridId = taskAction.getGridId();

        if (gridId != undefined && gridId !== '') {
          parameters.gridId = gridId;
        }

        var filterId = taskAction.getFilterId();

        if (filterId != undefined && filterId !== '') {
          parameters.filterId = filterId;
        }
      }

      return parameters;
    }
  }]);

  return SAIDashboardTile;
}(sai_dashboard_localizable_1.SAIDashboardLocalizable);

exports.SAIDashboardTile = SAIDashboardTile;

var SAIDashboardTaskTile = /*#__PURE__*/function (_SAIDashboardTile) {
  _inherits(SAIDashboardTaskTile, _SAIDashboardTile);

  var _super2 = _createSuper(SAIDashboardTaskTile);

  function SAIDashboardTaskTile() {
    _classCallCheck(this, SAIDashboardTaskTile);

    return _super2.apply(this, arguments);
  }

  _createClass(SAIDashboardTaskTile, [{
    key: "parseVisual",
    value: function parseVisual(visualConfig) {
      this.tileVisual = new sai_tilevisual_1.SAITaskTileVisual(visualConfig);
    }
  }, {
    key: "parseConfig",
    value: function parseConfig(tileConfig) {
      this.tileConfig = new sai_tileconfig_1.SAITaskTileConfig(tileConfig);
    }
  }, {
    key: "getVisual",
    value: function getVisual() {
      return this.tileVisual;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.tileConfig;
    }
  }]);

  return SAIDashboardTaskTile;
}(SAIDashboardTile);

exports.SAIDashboardTaskTile = SAIDashboardTaskTile;

var SAIDashboardGridTile = /*#__PURE__*/function (_SAIDashboardTile2) {
  _inherits(SAIDashboardGridTile, _SAIDashboardTile2);

  var _super3 = _createSuper(SAIDashboardGridTile);

  function SAIDashboardGridTile() {
    _classCallCheck(this, SAIDashboardGridTile);

    return _super3.apply(this, arguments);
  }

  _createClass(SAIDashboardGridTile, [{
    key: "parseVisual",
    value: function parseVisual(visualConfig) {
      this.tileVisual = new sai_tilevisual_1.SAIGridTileVisual(visualConfig);
    }
  }, {
    key: "parseConfig",
    value: function parseConfig(tileConfig) {
      this.tileConfig = new sai_tileconfig_1.SAIDataTileConfig(tileConfig);
    }
  }, {
    key: "parseContent",
    value: function parseContent(tileContent) {
      this.tileContent = new sai_tilecontent_1.SAITileContent(tileContent);
    }
  }, {
    key: "getVisual",
    value: function getVisual() {
      return this.tileVisual;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.tileConfig;
    }
  }]);

  return SAIDashboardGridTile;
}(SAIDashboardTile);

exports.SAIDashboardGridTile = SAIDashboardGridTile;

var SAIDashboardAgendaTile = /*#__PURE__*/function (_SAIDashboardTile3) {
  _inherits(SAIDashboardAgendaTile, _SAIDashboardTile3);

  var _super4 = _createSuper(SAIDashboardAgendaTile);

  function SAIDashboardAgendaTile() {
    _classCallCheck(this, SAIDashboardAgendaTile);

    return _super4.apply(this, arguments);
  }

  _createClass(SAIDashboardAgendaTile, [{
    key: "parseConfig",
    value: function parseConfig(tileConfig) {
      this.tileConfig = new sai_tileconfig_1.SAIAgendaTileConfig(tileConfig);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.tileConfig;
    }
  }]);

  return SAIDashboardAgendaTile;
}(SAIDashboardTile);

exports.SAIDashboardAgendaTile = SAIDashboardAgendaTile;

var SAIDashboardGraphTile = /*#__PURE__*/function (_SAIDashboardTile4) {
  _inherits(SAIDashboardGraphTile, _SAIDashboardTile4);

  var _super5 = _createSuper(SAIDashboardGraphTile);

  function SAIDashboardGraphTile() {
    _classCallCheck(this, SAIDashboardGraphTile);

    return _super5.apply(this, arguments);
  }

  _createClass(SAIDashboardGraphTile, [{
    key: "parseConfig",
    value: function parseConfig(tileConfig) {
      this.tileConfig = new sai_tileconfig_1.SAIGraphTileConfig(tileConfig);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.tileConfig;
    }
  }]);

  return SAIDashboardGraphTile;
}(SAIDashboardTile);

exports.SAIDashboardGraphTile = SAIDashboardGraphTile;

var SAIDashboardFilterTile = /*#__PURE__*/function (_SAIDashboardTile5) {
  _inherits(SAIDashboardFilterTile, _SAIDashboardTile5);

  var _super6 = _createSuper(SAIDashboardFilterTile);

  function SAIDashboardFilterTile() {
    _classCallCheck(this, SAIDashboardFilterTile);

    return _super6.apply(this, arguments);
  }

  _createClass(SAIDashboardFilterTile, [{
    key: "parseConfig",
    value: function parseConfig(tileConfig) {
      this.tileConfig = new sai_tileconfig_1.SAIFilterTileConfig(tileConfig);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.tileConfig;
    }
  }]);

  return SAIDashboardFilterTile;
}(SAIDashboardTile);

exports.SAIDashboardFilterTile = SAIDashboardFilterTile;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SAITileConfig = /*#__PURE__*/function () {
  function SAITileConfig(config) {
    _classCallCheck(this, SAITileConfig);

    this.config = config || {};
  }

  _createClass(SAITileConfig, [{
    key: "getId",
    value: function getId() {
      return this.config.id !== undefined ? this.config.id : '';
    }
  }, {
    key: "getTaskId",
    value: function getTaskId() {
      return this.config.taskId !== undefined ? this.config.taskId : '';
    }
  }, {
    key: "getRefreshRate",
    value: function getRefreshRate() {
      return this.config.refresh !== undefined ? this.config.refresh : 60;
    }
  }, {
    key: "hasToRefreshOnOpen",
    value: function hasToRefreshOnOpen() {
      return this.config.refreshOnOpen !== undefined ? this.config.refreshOnOpen : false;
    }
  }, {
    key: "getLabel",
    value: function getLabel() {
      return this.config.label !== undefined ? this.config.label : '';
    }
  }, {
    key: "setLabel",
    value: function setLabel(label) {
      this.config.label = label;
    }
  }, {
    key: "getShortLabel",
    value: function getShortLabel() {
      return this.config.shortLabel !== undefined ? this.config.shortLabel : '';
    }
  }, {
    key: "setShortLabel",
    value: function setShortLabel(shortLabel) {
      this.config.shortLabel = shortLabel;
    }
  }, {
    key: "getVeryShortLabel",
    value: function getVeryShortLabel() {
      return this.config.veryShortLabel !== undefined ? this.config.veryShortLabel : '';
    }
  }, {
    key: "setVeryShortLabel",
    value: function setVeryShortLabel(veryShortLabel) {
      this.config.veryShortLabel = veryShortLabel;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.config.description !== undefined ? this.config.description : '';
    }
  }, {
    key: "setDescription",
    value: function setDescription(description) {
      this.config.description = description;
    }
  }, {
    key: "getFilterConditions",
    value: function getFilterConditions() {
      return this.config.filteredBy !== undefined ? this.config.filteredBy : [];
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.config.enabled !== false;
    }
  }]);

  return SAITileConfig;
}();

exports.SAITileConfig = SAITileConfig;

var SAITaskTileConfig = /*#__PURE__*/function (_SAITileConfig) {
  _inherits(SAITaskTileConfig, _SAITileConfig);

  var _super = _createSuper(SAITaskTileConfig);

  function SAITaskTileConfig(config) {
    _classCallCheck(this, SAITaskTileConfig);

    return _super.call(this, config);
  }

  _createClass(SAITaskTileConfig, [{
    key: "getStart",
    value: function getStart() {
      return this.config.start !== undefined ? this.config.start : 0;
    }
  }, {
    key: "getEnd",
    value: function getEnd() {
      return this.config.end !== undefined ? this.config.end : -1;
    }
  }]);

  return SAITaskTileConfig;
}(SAITileConfig);

exports.SAITaskTileConfig = SAITaskTileConfig;

var SAIDataTileConfig = /*#__PURE__*/function (_SAITaskTileConfig) {
  _inherits(SAIDataTileConfig, _SAITaskTileConfig);

  var _super2 = _createSuper(SAIDataTileConfig);

  function SAIDataTileConfig(config) {
    _classCallCheck(this, SAIDataTileConfig);

    return _super2.call(this, config);
  }

  _createClass(SAIDataTileConfig, [{
    key: "getGridId",
    value: function getGridId() {
      return this.config.gridId !== undefined ? this.config.gridId : '';
    }
  }, {
    key: "getFormatterId",
    value: function getFormatterId() {
      return this.config.formatterId !== undefined ? this.config.formatterId : '';
    }
  }, {
    key: "getFilterId",
    value: function getFilterId() {
      return this.config.filterId !== undefined ? this.config.filterId : '';
    }
  }, {
    key: "getNoDataText",
    value: function getNoDataText() {
      return this.config.noDataText !== undefined ? this.config.noDataText : '';
    }
  }]);

  return SAIDataTileConfig;
}(SAITaskTileConfig);

exports.SAIDataTileConfig = SAIDataTileConfig;

var SAIAgendaTileConfig = /*#__PURE__*/function (_SAIDataTileConfig) {
  _inherits(SAIAgendaTileConfig, _SAIDataTileConfig);

  var _super3 = _createSuper(SAIAgendaTileConfig);

  function SAIAgendaTileConfig(config) {
    _classCallCheck(this, SAIAgendaTileConfig);

    return _super3.call(this, config);
  }

  _createClass(SAIAgendaTileConfig, [{
    key: "getAgendaConfig",
    value: function getAgendaConfig() {
      return this.config.agendaConfig !== undefined ? this.config.agendaConfig : '';
    }
  }]);

  return SAIAgendaTileConfig;
}(SAIDataTileConfig);

exports.SAIAgendaTileConfig = SAIAgendaTileConfig;

var SAIGraphTileConfig = /*#__PURE__*/function (_SAIDataTileConfig2) {
  _inherits(SAIGraphTileConfig, _SAIDataTileConfig2);

  var _super4 = _createSuper(SAIGraphTileConfig);

  function SAIGraphTileConfig(config) {
    _classCallCheck(this, SAIGraphTileConfig);

    return _super4.call(this, config);
  }

  _createClass(SAIGraphTileConfig, [{
    key: "getGraphConfig",
    value: function getGraphConfig() {
      return this.config.graphConfig !== undefined ? this.config.graphConfig : '';
    }
  }]);

  return SAIGraphTileConfig;
}(SAIDataTileConfig);

exports.SAIGraphTileConfig = SAIGraphTileConfig;

var SAIFilterTileConfig = /*#__PURE__*/function (_SAIDataTileConfig3) {
  _inherits(SAIFilterTileConfig, _SAIDataTileConfig3);

  var _super5 = _createSuper(SAIFilterTileConfig);

  function SAIFilterTileConfig(config) {
    _classCallCheck(this, SAIFilterTileConfig);

    return _super5.call(this, config);
  }

  _createClass(SAIFilterTileConfig, [{
    key: "canMultiSelect",
    value: function canMultiSelect() {
      return this.config.multiselection !== undefined ? this.config.multiselection : false;
    }
  }]);

  return SAIFilterTileConfig;
}(SAIDataTileConfig);

exports.SAIFilterTileConfig = SAIFilterTileConfig;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StringUtils_1 = __webpack_require__(2);

var SAITileVisual = /*#__PURE__*/function () {
  function SAITileVisual(config) {
    _classCallCheck(this, SAITileVisual);

    this.config = config || {};
  }

  _createClass(SAITileVisual, [{
    key: "getTitleColor",
    value: function getTitleColor(colors) {
      var color = this.config.titleColor !== undefined ? this.config.titleColor : '#fff';

      if (colors !== undefined && colors[color] !== undefined) {
        color = colors[color];
      }

      return color;
    }
  }, {
    key: "getTitleFontName",
    value: function getTitleFontName() {
      return this.config.titleFontName !== undefined ? this.config.titleFontName : 'Arial';
    }
  }, {
    key: "getBackgroundType",
    value: function getBackgroundType() {
      return this.config.backgroundType !== undefined ? this.config.backgroundType : 'color';
    }
  }, {
    key: "getBackgroundColor",
    value: function getBackgroundColor(colors, context) {
      var color = '#333';

      if (this.config.backgroundColor !== undefined) {
        color = StringUtils_1["default"].resolveTextProperties(this.config.backgroundColor, context);
      }

      if (colors !== undefined && colors[color] !== undefined) {
        color = colors[color];
      }

      var finalColor = this.hexToRgb(color);
      return finalColor === null ? this.hexToRgb('#333') : finalColor;
    }
  }, {
    key: "getBackgroundAlpha",
    value: function getBackgroundAlpha() {
      var value = this.config.backgroundAlpha;
      return value !== undefined ? value : 0.9;
    }
  }, {
    key: "getBackgroundImage",
    value: function getBackgroundImage(context) {
      return this.config.backgroundImage !== undefined ? StringUtils_1["default"].resolveTextProperties(this.config.backgroundImage, context) : '';
    }
  }, {
    key: "setBackgroundImage",
    value: function setBackgroundImage(newImage) {
      this.config.backgroundImage = newImage;
    }
  }, {
    key: "hexToRgb",
    value: function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return '#' + r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
  }, {
    key: "getTitlePosition",
    value: function getTitlePosition() {
      return this.config.titlePosition !== undefined ? this.config.titlePosition.toLowerCase() : 'top';
    }
  }, {
    key: "getVisible",
    value: function getVisible() {
      return this.config.visible !== undefined ? this.config.visible : 'true';
    }
  }]);

  return SAITileVisual;
}();

exports.SAITileVisual = SAITileVisual;

var SAITaskTileVisual = /*#__PURE__*/function (_SAITileVisual) {
  _inherits(SAITaskTileVisual, _SAITileVisual);

  var _super = _createSuper(SAITaskTileVisual);

  function SAITaskTileVisual(config) {
    _classCallCheck(this, SAITaskTileVisual);

    return _super.call(this, config);
  }

  _createClass(SAITaskTileVisual, [{
    key: "getIcon",
    value: function getIcon(context) {
      return this.config.icon ? StringUtils_1["default"].resolveTextProperties(this.config.icon, context) : '';
    }
  }, {
    key: "setIcon",
    value: function setIcon(newIcon) {
      this.config.icon = newIcon;
    }
  }, {
    key: "hasToShowIcon",
    value: function hasToShowIcon() {
      return this.config.showIcon;
    }
  }, {
    key: "getIconColor",
    value: function getIconColor() {
      return this.config.iconColor ? this.config.iconColor : '#fff';
    }
  }, {
    key: "hasToShowSecondaryIcon",
    value: function hasToShowSecondaryIcon() {
      return this.config.useSecondaryIcon !== undefined ? this.config.useSecondaryIcon : false;
    }
  }, {
    key: "getIconMaxHeight",
    value: function getIconMaxHeight() {
      return this.config.maxHeight;
    }
  }, {
    key: "getIconMaxWidth",
    value: function getIconMaxWidth() {
      return this.config.maxWidth;
    }
  }]);

  return SAITaskTileVisual;
}(SAITileVisual);

exports.SAITaskTileVisual = SAITaskTileVisual;

var SAIGridTileVisual = /*#__PURE__*/function (_SAITileVisual2) {
  _inherits(SAIGridTileVisual, _SAITileVisual2);

  var _super2 = _createSuper(SAIGridTileVisual);

  function SAIGridTileVisual(config) {
    _classCallCheck(this, SAIGridTileVisual);

    return _super2.call(this, config);
  }

  _createClass(SAIGridTileVisual, [{
    key: "getIcon",
    value: function getIcon() {
      return this.config.icon ? this.config.icon : '';
    }
  }]);

  return SAIGridTileVisual;
}(SAITileVisual);

exports.SAIGridTileVisual = SAIGridTileVisual;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SAITileAction = /*#__PURE__*/function () {
  function SAITileAction(config) {
    _classCallCheck(this, SAITileAction);

    this.config = config;
  }

  _createClass(SAITileAction, [{
    key: "getType",
    value: function getType() {
      return this.config.type !== undefined ? this.config.type : 'None';
    }
  }, {
    key: "getTaskId",
    value: function getTaskId() {
      return this.config.taskId;
    }
  }]);

  return SAITileAction;
}();

exports.SAITileAction = SAITileAction;

var SAITileTaskAction = /*#__PURE__*/function (_SAITileAction) {
  _inherits(SAITileTaskAction, _SAITileAction);

  var _super = _createSuper(SAITileTaskAction);

  function SAITileTaskAction(config) {
    _classCallCheck(this, SAITileTaskAction);

    return _super.call(this, config);
  }

  _createClass(SAITileTaskAction, [{
    key: "getFilterId",
    value: function getFilterId() {
      return this.config.filterId !== undefined ? this.config.filterId : '';
    }
  }, {
    key: "getGridId",
    value: function getGridId() {
      return this.config.gridId !== undefined ? this.config.gridId : '';
    }
  }]);

  return SAITileTaskAction;
}(SAITileAction);

exports.SAITileTaskAction = SAITileTaskAction;

var SAITileNotificationAction = /*#__PURE__*/function (_SAITileAction2) {
  _inherits(SAITileNotificationAction, _SAITileAction2);

  var _super2 = _createSuper(SAITileNotificationAction);

  function SAITileNotificationAction(config) {
    _classCallCheck(this, SAITileNotificationAction);

    return _super2.call(this, config);
  }

  _createClass(SAITileNotificationAction, [{
    key: "getNotification",
    value: function getNotification() {
      return this.config.notification !== undefined ? this.config.notification : '';
    }
  }, {
    key: "getNotificationSource",
    value: function getNotificationSource() {
      return this.config.notificationSource !== undefined ? this.config.notificationSource : '';
    }
  }, {
    key: "getNotificationTask",
    value: function getNotificationTask() {
      return this.config.notificationTask !== undefined ? this.config.notificationTask : '';
    }
  }]);

  return SAITileNotificationAction;
}(SAITileAction);

exports.SAITileNotificationAction = SAITileNotificationAction;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_tile_view_factory_1 = __webpack_require__(13);

var SAIDashboardGroupView = /*#__PURE__*/function () {
  function SAIDashboardGroupView(parentView, modelData) {
    _classCallCheck(this, SAIDashboardGroupView);

    this.parentView = parentView;
    this.model = modelData;
    this.parseTiles(this.model.getTiles());
  }

  _createClass(SAIDashboardGroupView, [{
    key: "parseTiles",
    value: function parseTiles(tileArray) {
      if (_typeof(tileArray) !== 'object') {
        console.error('tiles attribute must be defined as an array of tiles object. Expected [...] got ' + tileArray);
        return;
      }

      this.tileViews = [];
      this.tileViewsMap = {};

      for (var key in tileArray) {
        var newTile = sai_dashboard_tile_view_factory_1.SAITileViewFactory.buildTileView(tileArray[key], this.model, this);
        this.tileViews.push(newTile);
        this.tileViewsMap[newTile.model.getId()] = newTile;
      }
    }
  }, {
    key: "getTiles",
    value: function getTiles() {
      return this.tileViews;
    }
  }, {
    key: "getTile",
    value: function getTile(index) {
      return this.tileViews[index];
    }
  }, {
    key: "getTileById",
    value: function getTileById(id) {
      return this.tileViewsMap[id];
    }
  }, {
    key: "setElement",
    value: function setElement(newElement) {
      this.element = newElement;
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, startingTop, colors, globalProps) {
      this.element.addClass('sai-dashboard-group');
      this.element.attr('data-id', this.model.getId());
      this.renderPositionAndWidth(drawMode, squareSize, startingTop);
      var tileContentNode = this.renderContentNode();
      this.renderTiles(drawMode, tileContentNode, colors, globalProps);
      this.renderHeight(drawMode, squareSize, startingTop);
    }
  }, {
    key: "renderPositionAndWidth",
    value: function renderPositionAndWidth(drawMode, squareSize, startingTop) {
      if (drawMode === 'phone' || drawMode === 'tablet') {
        this.element.css({
          top: startingTop,
          left: 0
        });
      } else {
        this.element.css({
          top: this.model.getRow() * squareSize,
          left: this.model.getColumn() * squareSize,
          width: this.model.getWidth() * squareSize
        });
      }
    }
  }, {
    key: "renderHeight",
    value: function renderHeight(drawMode, squareSize, startingTop) {
      this.element.css({
        height: this.getRenderedHeight(drawMode, squareSize)
      });
    }
  }, {
    key: "renderContentNode",
    value: function renderContentNode() {
      var contentNode = $('<div></div>').appendTo(this.element);
      contentNode.addClass('sai-dashboard-group-contents');
      return contentNode;
    }
  }, {
    key: "renderTiles",
    value: function renderTiles(drawMode, contentNode, colors, globalProps) {
      var tiles = this.getTiles();
      var nextTopPosition = 0;
      var nextLeftPosition = 0;
      var squareSize = contentNode.width() / this.model.getWidth();
      var columnModeTileWidth = contentNode.width() / 2;

      for (var tileKey in tiles) {
        var tileElement = $('<div></div>').appendTo(contentNode);
        var currentTile = tiles[tileKey];
        currentTile.setElement(tileElement);

        if (drawMode === 'phone' || drawMode === 'tablet') {
          tileElement.width(columnModeTileWidth);
          currentTile.render(drawMode, squareSize, nextTopPosition, nextLeftPosition, colors, globalProps);

          if (currentTile.isVisible()) {
            var currentTopPosition = nextTopPosition;
            var currentLeftPosition = nextLeftPosition;
            nextTopPosition = currentTopPosition + (currentLeftPosition === 0 ? 0 : tileElement.height() + 5);
            nextLeftPosition = currentLeftPosition !== 0 ? 0 : columnModeTileWidth;
          }
        } else {
          currentTile.render(drawMode, squareSize, -1, -1, colors, globalProps);
        }
      }
    }
  }, {
    key: "getRenderedHeight",
    value: function getRenderedHeight(drawMode, squareSize) {
      var currentWidth = this.element ? this.element.width() : -1;
      var tileHeight;

      if (currentWidth < 0) {
        return -1;
      }

      if (drawMode === 'phone' || drawMode === 'tablet') {
        var tileCounter = 0;

        for (var tileKey in this.tileViews) {
          if (this.tileViews[tileKey].isVisible()) {
            tileCounter++;

            if (!tileHeight) {
              tileHeight = this.tileViews[tileKey].getRenderedPosition().height;
            }
          }
        }

        var nbTileRows = Math.ceil(tileCounter / 2);
        return nbTileRows * tileHeight + 20;
      } else {
        return this.model.getHeight() * squareSize;
      }
    }
  }, {
    key: "getTopPosition",
    value: function getTopPosition(squareSize) {
      return this.model.getRow() * squareSize;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.model.getId();
    }
  }, {
    key: "setBaseContext",
    value: function setBaseContext(baseContext) {
      this.baseContext = baseContext;
      var tiles = this.getTiles();

      for (var tileId in tiles) {
        tiles[tileId].setBaseContext(baseContext);
      }
    }
  }, {
    key: "setGlobalProperties",
    value: function setGlobalProperties(props) {
      this.globalProps = props;
      var tiles = this.getTiles();

      for (var tileId in tiles) {
        tiles[tileId].setGlobalProperties(props);
      }
    }
  }, {
    key: "setThemeColors",
    value: function setThemeColors(colors) {
      this.colors = colors;
      var tiles = this.getTiles();

      for (var tileId in tiles) {
        tiles[tileId].setThemeColors(colors);
      }
    }
  }]);

  return SAIDashboardGroupView;
}();

exports.SAIDashboardGroupView = SAIDashboardGroupView;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_dashboard_tile_view_1 = __webpack_require__(14);

var SAITileViewFactory = /*#__PURE__*/function () {
  function SAITileViewFactory() {
    _classCallCheck(this, SAITileViewFactory);
  }

  _createClass(SAITileViewFactory, null, [{
    key: "buildTileView",
    value: function buildTileView(tileConfig, parent, parentView) {
      if (!tileConfig || !tileConfig.getType()) {
        throw new Error('Invalid tile config. Config should be at least an object with a type property.');
      }

      var type = tileConfig.getType();

      if (type === 'Task') {
        return new sai_dashboard_tile_view_1.SAIDashboardTaskTileView(tileConfig, parentView);
      } else if (type === 'Title') {
        return new sai_dashboard_tile_view_1.SAIDashboardTitleTileView(tileConfig, parentView);
      } else if (type === 'Grid') {
        return new sai_dashboard_tile_view_1.SAIDashboardGridTileView(tileConfig, parentView);
      } else if (type === 'Agenda') {
        return new sai_dashboard_tile_view_1.SAIDashboardAgendaTileView(tileConfig, parentView);
      } else if (type === 'Filter') {
        return new sai_dashboard_tile_view_1.SAIDashboardFilterTileView(tileConfig, parentView);
      } else if (type === 'Graph') {
        return new sai_dashboard_tile_view_1.SAIDashboardGraphTileView(tileConfig, parentView);
      } else {
        throw new Error('Non valid tile type : ' + type);
      }
    }
  }]);

  return SAITileViewFactory;
}();

exports.SAITileViewFactory = SAITileViewFactory;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sai_tilecontent_1 = __webpack_require__(3);

var Constants_1 = __webpack_require__(15);

var StringUtils_1 = __webpack_require__(2);

var SAIDashboardTileView = /*#__PURE__*/function () {
  function SAIDashboardTileView(model, parentView) {
    _classCallCheck(this, SAIDashboardTileView);

    this.model = model;
    this.parentView = parentView;
    this.filteringTiles = [];
  }

  _createClass(SAIDashboardTileView, [{
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      this.colors = colors;
      this.globalProps = globalProps;
      this.element.addClass('sai-dashboard-tile');
      this.element.attr('data-id', this.model.getId());
      this.renderPositionAndSize(drawMode, squareSize, topPosition, leftPosition);
      var contentNode = this.renderContentNode();
      this.renderBackground(contentNode);

      if (!this.checkIfVisible()) {
        this.element.hide();
      }

      this.renderTitle(contentNode);
      this.renderBodyContent(contentNode);

      if (!this.model.getConfig().isEnabled()) {
        $('<div></div>').addClass('disabled').prependTo(contentNode);
        this.element.addClass('disabled');
      }

      return contentNode;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle(contentNode, variableContext) {
      this.titleRootNode = contentNode.find('.sai-dashboard-tile-title');

      if (this.titleRootNode.length === 0) {
        this.titleRootNode = $('<div></div>').addClass('sai-dashboard-tile-title').addClass('title').appendTo(contentNode);
      } else {
        this.titleRootNode.css({
          width: 'auto'
        });
      }

      var titleHeight;
      var visual = this.model.getVisual();
      var viewportWidth = $('body').width();

      if (viewportWidth < Constants_1.SCREEN_PHONE_MAX_WIDTH) {
        titleHeight = '10pt';
      } else if (viewportWidth < Constants_1.SCREEN_TABLET_MAX_WIDTH) {
        titleHeight = '16pt';
      } else {
        titleHeight = '14pt';
      }

      this.titleRootNode.css({
        'font-size': titleHeight,
        'font-family': visual.getTitleFontName(),
        'color': visual.getTitleColor(this.colors),
        'text-overflow': 'ellipsis',
        'overflow': 'hidden'
      });
      var resolveContext = $.extend({}, this.baseContext || {}, variableContext || {}, this.globalProps || {});
      var tileConfig = this.model.getConfig();
      var hasLabel = (tileConfig.getLabel() || tileConfig.getShortLabel() || tileConfig.getVeryShortLabel()) !== '';

      if (!hasLabel) {
        this.titleRootNode.height(0);
        this.titleRootNode.hide();
      } else {
        this.titleRootNode.show();
        var resLabel = StringUtils_1["default"].resolveTextProperties(tileConfig.getLabel(), resolveContext);
        this.titleRootNode.text(resLabel);
        var contentNodeWidth = contentNode.width();
        var titleMargin = this.titleRootNode.outerWidth(true) - this.titleRootNode.innerWidth();
        var maxWidth = contentNodeWidth - titleMargin;

        if (this.titleRootNode[0].clientWidth > maxWidth && tileConfig.getShortLabel() !== '') {
          this.titleRootNode.text(StringUtils_1["default"].resolveTextProperties(tileConfig.getShortLabel(), resolveContext));
        }

        if (this.titleRootNode[0].clientWidth > maxWidth && tileConfig.getVeryShortLabel() !== '') {
          this.titleRootNode.text(StringUtils_1["default"].resolveTextProperties(tileConfig.getVeryShortLabel(), resolveContext));
        }

        this.titleRootNode.css({
          'width': maxWidth + 'px'
        });
      }
    }
  }, {
    key: "renderBodyContent",
    value: function renderBodyContent(contentNode) {}
  }, {
    key: "checkIfVisible",
    value: function checkIfVisible() {
      var baseVisible = StringUtils_1["default"].resolveTextProperties(this.model.getVisual().getVisible(), this.globalProps);

      if (baseVisible !== 'true') {
        return false;
      }

      var filterConditions = this.model.getConfig().getFilterConditions();
      var showIt = filterConditions.length === 0;

      if (showIt) {
        return true;
      }

      for (var condKey in filterConditions) {
        var currentCondition = filterConditions[condKey];
        var innerShowIt = !currentCondition.visibleOnFilter || currentCondition.visibleOnFilter.length === 0;

        if (innerShowIt) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "renderContentNode",
    value: function renderContentNode() {
      this.contentNode = $('<div></div>').appendTo(this.element);
      this.contentNode.addClass('sai-dashboard-tile-contents');
      var emptyHeight = this.contentNode.outerHeight(true);
      var emptyWidth = this.contentNode.outerWidth(true);
      this.contentNode.css({
        height: this.element.height() - emptyHeight,
        width: this.element.width() - emptyWidth
      });
      this.bindContentNodeClick(this.contentNode);
      return this.contentNode;
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(contentNode) {
      this.backgroundNode = $('<div></div>').addClass('tile-background-image').appendTo(contentNode);
      this.refreshBackground();
    }
  }, {
    key: "onBackgroundImageReceived",
    value: function onBackgroundImageReceived(contentNode, result) {
      result.then(function (value) {
        contentNode.addClass('tile-background-image');
        contentNode.css('background-image', 'url(\'' + value + '\')');
      });
    }
  }, {
    key: "renderPositionAndSize",
    value: function renderPositionAndSize(drawMode, squareSize, topPosition, leftPosition) {
      if (drawMode === 'phone' || drawMode === 'tablet') {
        this.element.css({
          top: topPosition,
          left: leftPosition,
          height: Math.min(300, this.element.width())
        });
      } else {
        this.element.css({
          top: this.model.getRow() * squareSize,
          left: this.model.getColumn() * squareSize,
          width: this.model.getWidth() * squareSize,
          height: this.model.getHeight() * squareSize
        });
      }
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'Tile';
    }
  }, {
    key: "setElement",
    value: function setElement(element) {
      this.element = element;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.element.is(':visible');
    }
  }, {
    key: "getRenderedPosition",
    value: function getRenderedPosition() {
      return {
        top: this.element.position().top,
        height: this.element.outerHeight(true)
      };
    }
  }, {
    key: "setBaseContext",
    value: function setBaseContext(baseContext) {
      this.baseContext = baseContext;
    }
  }, {
    key: "bindContentNodeClick",
    value: function bindContentNodeClick(contentNode) {
      var me = this;
      var enabled = this.model.getConfig().isEnabled();

      if (enabled) {
        contentNode.on('click', function (event) {
          event.stopPropagation();
          $(this).trigger('SAITileClick', me.model);
        });
      }

      var cursor = enabled ? 'pointer' : 'not-allowed';
      contentNode.css({
        cursor: cursor
      });
    }
  }, {
    key: "refreshTile",
    value: function refreshTile(data) {
      this.refreshVisibility();
      this.renderTitle(this.contentNode, data ? data.sessionVars : {});
      this.refreshBackground();
    }
  }, {
    key: "refreshVisibility",
    value: function refreshVisibility() {
      if (!this.checkIfVisible()) {
        this.element.hide();
      } else {
        this.element.show();
      }
    }
  }, {
    key: "refreshBackground",
    value: function refreshBackground() {
      var visual = this.model.getVisual();
      var backgroundType = visual.getBackgroundType();

      if (backgroundType === 'Color') {
        var color = visual.getBackgroundColor(this.colors, this.globalProps);
        var alpha = visual.getBackgroundAlpha();
        var finalColor = 'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + alpha + ')';
        this.backgroundNode.css('background-color', finalColor);
      } else if (backgroundType === 'Image') {
        var image = visual.getBackgroundImage(this.globalProps);

        if (image && image !== this.currentBackgroundImage) {
          this.currentBackgroundImage = image;
          var dataConfig = {
            resource: image,
            context: 'tileBackgroundImage'
          };
          this.element.trigger('SAIResourceRequest', [this.model.getId(), dataConfig, this.onBackgroundImageReceived.bind(this, this.backgroundNode)]);
        }

        var _alpha = visual.getBackgroundAlpha();

        if (_alpha) {
          this.backgroundNode.css('opacity', _alpha);
        }
      }
    }
  }, {
    key: "setGlobalProperties",
    value: function setGlobalProperties(props) {
      this.globalProps = props;
    }
  }, {
    key: "setThemeColors",
    value: function setThemeColors(colors) {
      this.colors = colors;
    }
  }]);

  return SAIDashboardTileView;
}();

exports.SAIDashboardTileView = SAIDashboardTileView;

var SAIDashboardTitleTileView = /*#__PURE__*/function (_SAIDashboardTileView) {
  _inherits(SAIDashboardTitleTileView, _SAIDashboardTileView);

  var _super = _createSuper(SAIDashboardTitleTileView);

  function SAIDashboardTitleTileView() {
    _classCallCheck(this, SAIDashboardTitleTileView);

    return _super.apply(this, arguments);
  }

  _createClass(SAIDashboardTitleTileView, [{
    key: "getType",
    value: function getType() {
      return 'Title';
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      var contentNode = _get(_getPrototypeOf(SAIDashboardTitleTileView.prototype), "render", this).call(this, drawMode, squareSize, topPosition, leftPosition, colors, globalProps);

      this.element.attr('data-type', 'title');
      return contentNode;
    }
  }, {
    key: "bindContentNodeClick",
    value: function bindContentNodeClick(contentNode) {}
  }]);

  return SAIDashboardTitleTileView;
}(SAIDashboardTileView);

exports.SAIDashboardTitleTileView = SAIDashboardTitleTileView;

var SAIDashboardTaskTileView = /*#__PURE__*/function (_SAIDashboardTileView2) {
  _inherits(SAIDashboardTaskTileView, _SAIDashboardTileView2);

  var _super2 = _createSuper(SAIDashboardTaskTileView);

  function SAIDashboardTaskTileView() {
    _classCallCheck(this, SAIDashboardTaskTileView);

    return _super2.apply(this, arguments);
  }

  _createClass(SAIDashboardTaskTileView, [{
    key: "getType",
    value: function getType() {
      return 'Task';
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      var contentNode = _get(_getPrototypeOf(SAIDashboardTaskTileView.prototype), "render", this).call(this, drawMode, squareSize, topPosition, leftPosition, colors, globalProps);

      this.element.attr('data-type', 'task');
      this.updateTitlePosition(contentNode);
      return contentNode;
    }
  }, {
    key: "renderBodyContent",
    value: function renderBodyContent(contentNode) {
      this.refreshIcon(contentNode);
    }
  }, {
    key: "refreshIcon",
    value: function refreshIcon(contentNode) {
      var visual = this.model.getVisual();

      if (visual) {
        var icon = visual.getIcon(this.globalProps);
        var dataConfig = {
          resource: icon,
          context: 'tileIcon'
        };

        if (icon && this.currentIcon !== icon) {
          this.currentIcon = icon;
          this.element.trigger('SAIResourceRequest', [this.model.getId(), dataConfig, this.onIconReceived.bind(this, contentNode)]);
        }
      }
    }
  }, {
    key: "onIconReceived",
    value: function onIconReceived(contentNode, icon) {
      var _this = this;

      icon.then(function (url) {
        var me = _this;
        var isSvg = url.split('.').pop() === 'svg';
        var loadPromise;

        if (isSvg) {
          loadPromise = new Promise(function (resolve, reject) {
            $.get(url, function (data) {
              var svg = $(new XMLSerializer().serializeToString(data.documentElement)).appendTo(contentNode);
              resolve(svg);
            });
          });
        } else {
          var iconHolder = $('<img />').appendTo(contentNode);
          loadPromise = new Promise(function (resolve, reject) {
            iconHolder.on('load', function () {
              resolve(iconHolder);
            });
            iconHolder.on('error', function () {
              reject(iconHolder);
            });
            iconHolder.attr('src', url);
          });
        }

        loadPromise.then(_this.resizeImage.bind(_this, contentNode, isSvg))["catch"](function () {
          console.info('Unable to load icon' + url);
        });
      })["catch"](function () {
        console.info('Failed to fetch resource');
      });
    }
  }, {
    key: "resizeImage",
    value: function resizeImage(contentNode, byAttribute, imgNode) {
      var maxHeight = this.model.getVisual().getIconMaxHeight();
      var maxWidth = this.model.getVisual().getIconMaxWidth();
      var maxHeightFactor = maxHeight ? maxHeight : 0.5;
      var height = maxHeightFactor * contentNode.height();
      var maxWidthFactor = maxWidth ? maxWidth : 0.5;
      var width = maxWidthFactor * contentNode.width();
      var imgHeight;
      var imgWidth;

      if (byAttribute) {
        imgHeight = parseFloat(imgNode.attr('height'));
        imgWidth = parseFloat(imgNode.attr('width'));
      } else {
        imgHeight = imgNode.height();
        imgWidth = imgNode.width();
      }

      var hRatio = imgHeight / height;
      var wRatio = imgWidth / width;
      var maxRatio = Math.max(hRatio, wRatio);

      if (byAttribute) {
        imgNode.attr('height', imgHeight / maxRatio);
        imgNode.attr('width', imgWidth / maxRatio);
      } else {
        imgNode.height(imgHeight / maxRatio);
        imgNode.width(imgWidth / maxRatio);
      }

      imgNode.addClass('tile-icon');
      this.updateTitlePosition(contentNode);
    }
  }, {
    key: "updateTitlePosition",
    value: function updateTitlePosition(contentNode) {
      var tileConfig = this.model.getConfig();
      var visual = this.model.getVisual();

      if (visual.getTitlePosition() === 'middle' || visual.getTitlePosition() === 'bottom') {
        var nextElement = this.titleRootNode.next();
        var availableSpace;
        var margin = parseInt(this.titleRootNode.css('margin'));

        if (nextElement == undefined || nextElement.length == 0) {
          availableSpace = contentNode.innerHeight() - 2 * margin;
        } else {
          availableSpace = (contentNode.innerHeight() - nextElement.height()) / 2 - 2 * margin;
        }

        availableSpace = availableSpace < 0 ? 0 : availableSpace;
        this.titleRootNode.css({
          'text-align': 'center',
          'line-height': availableSpace + 'px'
        });

        if (visual.getTitlePosition() === 'bottom') {
          var marginTop = contentNode.innerHeight() - (this.titleRootNode.innerHeight() + 10);

          if (visual.getIconMaxHeight()) {
            var iconHeight = contentNode.innerHeight() * visual.getIconMaxHeight();
            var tileRemainingPlace = contentNode.innerHeight() - iconHeight;
            var marginTopAlt = iconHeight + tileRemainingPlace / 2 + 5;
            marginTop = marginTopAlt < marginTop ? marginTopAlt : marginTop;
          }

          this.titleRootNode.css({
            'margin-top': marginTop + 'px',
            'line-height': 'unset'
          });
        }
      }
    }
  }, {
    key: "refreshTile",
    value: function refreshTile(data) {
      _get(_getPrototypeOf(SAIDashboardTaskTileView.prototype), "refreshTile", this).call(this, data);

      this.refreshIcon(this.contentNode);
    }
  }]);

  return SAIDashboardTaskTileView;
}(SAIDashboardTileView);

exports.SAIDashboardTaskTileView = SAIDashboardTaskTileView;

var SAIDashboardGridTileView = /*#__PURE__*/function (_SAIDashboardTileView3) {
  _inherits(SAIDashboardGridTileView, _SAIDashboardTileView3);

  var _super3 = _createSuper(SAIDashboardGridTileView);

  function SAIDashboardGridTileView() {
    _classCallCheck(this, SAIDashboardGridTileView);

    return _super3.apply(this, arguments);
  }

  _createClass(SAIDashboardGridTileView, [{
    key: "getType",
    value: function getType() {
      return 'Grid';
    }
  }, {
    key: "getData",
    value: function getData(start, end) {
      var currentConfig = this.model.getConfig();

      if (currentConfig.isEnabled()) {
        var dataConfig = {
          taskId: currentConfig.getTaskId(),
          gridId: currentConfig.getGridId(),
          start: start,
          end: end,
          formatterId: currentConfig.getFormatterId(),
          filterId: currentConfig.getFilterId()
        };
        this.element.trigger('SAIDataRequest', [this.model.getId(), dataConfig, this.onDataReceived.bind(this)]);
      }
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      var contentNode = _get(_getPrototypeOf(SAIDashboardGridTileView.prototype), "render", this).call(this, drawMode, squareSize, topPosition, leftPosition, colors, globalProps);

      this.element.attr('data-type', 'grid');
      return contentNode;
    }
  }, {
    key: "onDataReceived",
    value: function onDataReceived(data) {
      var _this2 = this;

      data.then(function (result) {
        if (!result) {
          result = {};
        }

        _this2.renderTitle(_this2.contentNode, result.sessionVars);

        _this2.renderGridContent(result);
      })["catch"](function (failure) {
        console.info('the data promise failed');
      });
    }
  }, {
    key: "renderBodyContent",
    value: function renderBodyContent(contentNode) {
      this.gridContentTableNode = $('<div></div>').addClass('sai-dashboard-tile-grid-body').appendTo(contentNode);
      var titleHeight = this.titleRootNode.outerHeight(true);
      var emptyGridHeight = this.gridContentTableNode.outerHeight(true);
      var marginTop = this.gridContentTableNode.css('margin-top');
      var marginTopValue = marginTop.indexOf('px') > 0 ? parseFloat(marginTop.substring(0, marginTop.length)) : parseFloat(marginTop);
      this.gridContentTableNode.height(this.element.height() - emptyGridHeight - titleHeight);
      this.getData(-1, -1);
    }
  }, {
    key: "renderGridContent",
    value: function renderGridContent(result) {
      var visual = this.model.getVisual();
      var gridContent = new sai_tilecontent_1.SAITileContent(result);
      this.gridContentTableNode.empty();
      var presentation = this.model.getPresentation();
      var contentHeaders = gridContent.getHeaders();
      var contentItems = gridContent.getItems();
      var tableContent = $('<div></div>').addClass('grid-table-content').appendTo(this.gridContentTableNode);

      if (presentation === 'Grid') {
        var GridTableHeader = $('<div></div>').addClass('grid-table-row header').appendTo(tableContent);

        for (var index in contentHeaders) {
          if (!contentHeaders[index].hidden) {
            var gridHeaderItem = $('<div></div>').addClass('grid-table-item header').appendTo(GridTableHeader);
            gridHeaderItem.text(contentHeaders[index].text ? contentHeaders[index].text : ' ');
          }
        }
      }

      for (var itemIndex in contentItems) {
        var gridTableItem = $('<div></div>').addClass('grid-table-row').appendTo(tableContent);
        var itemColumns = contentItems[itemIndex].columns;

        if (!presentation || presentation === 'Grid') {
          var color = visual.getBackgroundColor(this.colors, this.globalProps);
          var magicValue = (color.r * 299 + color.g * 587 + color.b * 114) / 1000;
          var textColor = magicValue > 125 ? 'black' : 'white';
          gridTableItem.css('color', textColor);

          for (var columnIndex in contentHeaders) {
            var gridItem = $('<div></div>').addClass('grid-table-item').appendTo(gridTableItem);

            if (columnIndex === '0') {
              gridItem.addClass('first');
            }

            var itemColumn = contentItems[itemIndex].getColumnByDataIndex(contentHeaders[columnIndex].dataIndex);

            if (itemColumn.key) {
              gridItem.addClass('grid-table-key');
            }

            gridItem.text(itemColumn.value);
          }
        } else if (presentation === 'TodoList') {
          var item = contentItems[itemIndex];
          var itemIcon = $('<div></div>').addClass('grid-table-icon').appendTo(gridTableItem);
          var dataConfig = {
            resource: item.iconNote ? item.iconNote : item.icon,
            context: 'tileIcon'
          };

          if (dataConfig.resource) {
            this.element.trigger('SAIResourceRequest', [this.model.getId(), dataConfig, this.onGridIconReceived.bind(this, itemIcon)]);
          }

          var _gridItem = $('<div></div>').addClass('grid-todo-item').appendTo(gridTableItem);

          _gridItem.css('color', visual.getTitleColor(this.colors) || 'white');

          var finalLineText = '';

          for (var columnIndex in contentHeaders) {
            var column = contentHeaders[columnIndex];
            var itemColumn = contentItems[itemIndex].getColumnByDataIndex(column.dataIndex);

            if (!column.hidden) {
              if (finalLineText !== '') {
                finalLineText = finalLineText + ' ';
              }

              finalLineText += itemColumn.value;
            }
          }

          _gridItem.text(finalLineText);
        }
      }
    }
  }, {
    key: "onGridIconReceived",
    value: function onGridIconReceived(contentNode, result) {
      result.then(function (value) {
        contentNode.css('background-image', 'url(\'' + value + '\')');
      });
    }
  }, {
    key: "refreshTile",
    value: function refreshTile(data) {
      _get(_getPrototypeOf(SAIDashboardGridTileView.prototype), "refreshTile", this).call(this, data);

      if (data) {
        this.renderTitle(this.contentNode, data.sessionVars);
        this.renderGridContent(data);
      } else {
        this.renderTitle(this.contentNode, {});
      }
    }
  }]);

  return SAIDashboardGridTileView;
}(SAIDashboardTileView);

exports.SAIDashboardGridTileView = SAIDashboardGridTileView;

var SAIDashboardAgendaTileView = /*#__PURE__*/function (_SAIDashboardTileView4) {
  _inherits(SAIDashboardAgendaTileView, _SAIDashboardTileView4);

  var _super4 = _createSuper(SAIDashboardAgendaTileView);

  function SAIDashboardAgendaTileView() {
    _classCallCheck(this, SAIDashboardAgendaTileView);

    return _super4.apply(this, arguments);
  }

  _createClass(SAIDashboardAgendaTileView, [{
    key: "getType",
    value: function getType() {
      return 'Agenda';
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      var contentNode = _get(_getPrototypeOf(SAIDashboardAgendaTileView.prototype), "render", this).call(this, drawMode, squareSize, topPosition, leftPosition, colors, globalProps);

      this.element.attr('data-type', 'agenda');
      return contentNode;
    }
  }]);

  return SAIDashboardAgendaTileView;
}(SAIDashboardTileView);

exports.SAIDashboardAgendaTileView = SAIDashboardAgendaTileView;

var SAIDashboardGraphTileView = /*#__PURE__*/function (_SAIDashboardTileView5) {
  _inherits(SAIDashboardGraphTileView, _SAIDashboardTileView5);

  var _super5 = _createSuper(SAIDashboardGraphTileView);

  function SAIDashboardGraphTileView() {
    _classCallCheck(this, SAIDashboardGraphTileView);

    return _super5.apply(this, arguments);
  }

  _createClass(SAIDashboardGraphTileView, [{
    key: "getType",
    value: function getType() {
      return 'Graph';
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      var contentNode = _get(_getPrototypeOf(SAIDashboardGraphTileView.prototype), "render", this).call(this, drawMode, squareSize, topPosition, leftPosition, colors, globalProps);

      this.element.attr('data-type', 'graph');
      return contentNode;
    }
  }]);

  return SAIDashboardGraphTileView;
}(SAIDashboardTileView);

exports.SAIDashboardGraphTileView = SAIDashboardGraphTileView;

var SAIDashboardFilterTileView = /*#__PURE__*/function (_SAIDashboardTileView6) {
  _inherits(SAIDashboardFilterTileView, _SAIDashboardTileView6);

  var _super6 = _createSuper(SAIDashboardFilterTileView);

  function SAIDashboardFilterTileView() {
    _classCallCheck(this, SAIDashboardFilterTileView);

    return _super6.apply(this, arguments);
  }

  _createClass(SAIDashboardFilterTileView, [{
    key: "getType",
    value: function getType() {
      return 'Filter';
    }
  }, {
    key: "render",
    value: function render(drawMode, squareSize, topPosition, leftPosition, colors, globalProps) {
      var contentNode = _get(_getPrototypeOf(SAIDashboardFilterTileView.prototype), "render", this).call(this, drawMode, squareSize, topPosition, leftPosition, colors, globalProps);

      this.element.attr('data-type', 'filter');
      return contentNode;
    }
  }]);

  return SAIDashboardFilterTileView;
}(SAIDashboardTileView);

exports.SAIDashboardFilterTileView = SAIDashboardFilterTileView;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCREEN_XS_PHONE_MAX_WIDTH = 300;
exports.SCREEN_XS_PHONE_MAX_WIDTH = SCREEN_XS_PHONE_MAX_WIDTH;
var SCREEN_PHONE_MAX_WIDTH = 500;
exports.SCREEN_PHONE_MAX_WIDTH = SCREEN_PHONE_MAX_WIDTH;
var SCREEN_TABLET_MAX_WIDTH = 1199;
exports.SCREEN_TABLET_MAX_WIDTH = SCREEN_TABLET_MAX_WIDTH;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(17);
module.exports = __webpack_require__(4);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })
/******/ ]);
});
//# sourceMappingURL=sai-dashboard.js.map